import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    div: {
        width: "100%",
    },
}));
export default useStyles;
